import i18n from "@/i18n";
import DashboardKPICard from "@/modules/configurable-dashboard/Card/DashboardKPICard";
import StringUtils from "@/utils/StringUtils";
import { Invoice } from "../../RAInterfaces";
// import "./RAInvoicePaymentKPI.scss";

interface RAInvoicePaymentKPIProps {
  invoice: Invoice;
}
const RAInvoicePaymentKPI = (props: RAInvoicePaymentKPIProps) => {
  return (
    <>
      {props.invoice.data.status !== "declined" &&
        props.invoice.data.status !== "init" && (
          <div className={`opos-view __flex __flex-wrap`}>
            <div className={`__card-light padding-10`}>
              <DashboardKPICard
                value={props.invoice.data.opos?.value}
                format={(value) => StringUtils.formatCurrency(value)}
                title={i18n.t(
                  "ra:InvoiceDetails.opos.fullAmount",
                  "Gesamtbetrag"
                )}
              />
            </div>
            <div className={`__card-light padding-10`}>
              <DashboardKPICard
                value={props.invoice.data.opos?.booked}
                format={(value) => StringUtils.formatCurrency(value)}
                title={i18n.t(
                  "ra:InvoiceDetails.opos.bookedValue",
                  "Gebuchter Betrag"
                )}
              />
            </div>
            <div className={`__card-light padding-10`}>
              <DashboardKPICard
                value={props.invoice.data.opos?.openSum7Days}
                format={(value) => StringUtils.formatCurrency(value)}
                title={i18n.t(
                  "ra:InvoiceDetails.opos.openSum7Days",
                  "Aktuell offen"
                )}
                subTitle={i18n.t(
                  "ra:InvoiceDetails.opos.openSum7DaysSub",
                  "innerhalb der nächsten 7 Tage"
                )}
              />
            </div>
            <div className={`__card-light padding-10`}>
              <DashboardKPICard
                value={props.invoice.data.opos?.completeOpen}
                format={(value) => StringUtils.formatCurrency(value)}
                title={i18n.t(
                  "ra:InvoiceDetails.opos.completeOpen",
                  "Gesamt offen"
                )}
                subTitle={i18n.t(
                  "ra:InvoiceDetails.opos.completeOpen",
                  "bis Rechnung ausgeglichen ist"
                )}
              />
            </div>
          </div>
        )}
    </>
  );
};

export default RAInvoicePaymentKPI;
